import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { StyledButton } from './styles';
import { Icon } from '../Icon';
import { SpinnerIcon } from '../Icons';
/**
 * Basic button
 */

var Button = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      btnType = _ref.btnType,
      variant = _ref.variant,
      color = _ref.color,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      props = _objectWithoutProperties(_ref, ["children", "id", "disabled", "size", "btnType", "variant", "color", "isLoading"]);

  var _variant = variant || btnType || 'default';

  var invert = ['link', 'default', 'flat',
  /** DEPRECATED ---> */
  'subtle'].includes(_variant);
  var hideBorder = ['link',
  /** DEPRECATED ---> */
  'subtle'].includes(_variant);
  var hideShadows = ['link', 'flat', 'primaryFlat',
  /** DEPRECATED ---> */
  'subtle'].includes(_variant);
  var isDisabled = disabled || isLoading;
  var colorScheme = color || (['link', 'default', 'flat', 'primaryFlat'].includes(_variant) ? 'primary' : _variant) || 'primary';
  return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
    id: id,
    disabled: isDisabled,
    size: size,
    scheme: colorScheme,
    border: !hideBorder,
    invert: invert,
    shadows: !hideShadows
  }, props, {
    ref: ref
  }), isLoading && /*#__PURE__*/React.createElement(Icon, {
    icon: SpinnerIcon,
    size: "md",
    spin: true,
    mr: 1
  }), children);
});
export { Button };